<div class='main-nav'>
  <div class='navbar navbar-inverse'>
    <div class='navbar-header'>
      <button type='button' class='navbar-toggle' data-toggle='collapse' data-target='.navbar-collapse' [attr.aria-expanded]='isExpanded' (click)='toggle()'>
        <span class='sr-only'>Toggle navigation</span>
        <span class='icon-bar'></span>
        <span class='icon-bar'></span>
        <span class='icon-bar'></span>
      </button>
      <a class='navbar-brand' [routerLink]='["/"]' (dblclick)="toggleCat()">
        <img src="assets/CollectorAssistantToolLogoWhite.png" />
      </a>
      <app-cat #cat></app-cat>
    </div>
    <div class='clearfix'></div>
    <div class='navbar-collapse collapse mainmenu' [ngClass]='{ "in": isExpanded }'>
      <ul class='nav navbar-nav'>
        <li [routerLinkActive]='["link-active"]' *ngIf="auth.authenticated && auth.user && auth.user.midStageAccountsAccess">
          <a [routerLink]='["/midstage-accounts"]' (click)='collapse()'>
            <span class='glyphicon glyphicon-list-alt'></span> Accounts
          </a>
          <ul class="stats">
            <li>
              <ul>
                <li class="total">
                  <span>Total <span class="badge">{{ accountStats.midstageTotal }}</span></span>
                </li>
                <li class="todo">
                  <span>Todo <span class="badge">{{ accountStats.midstageTodo }}</span></span>
                  <div class="percentage" [ngStyle]="{'width': accountStats.midstageTodo * 100 / accountStats.midstageTotal + '%'}"></div>
                </li>
                <li class="worked">
                  <span>Worked <span class="badge">{{ accountStats.midstageWorked }}</span></span>
                  <div class="percentage" [ngStyle]="{'width': accountStats.midstageWorked * 100 / accountStats.midstageTotal + '%'}"></div>
                </li>
                <li class="done">
                  <span>Done <span class="badge">{{ accountStats.midstageDone }}</span></span>
                  <div class="percentage" [ngStyle]="{'width': accountStats.midstageDone * 100 / accountStats.midstageTotal + '%'}"></div>
                </li>
              </ul>
            </li>
          </ul>
        </li>
        <li [routerLinkActive]='["link-active"]' *ngIf="auth.authenticated && auth.user && auth.user.deactivatedNumbersAccess">
          <a [routerLink]='["/deactivated-numbers"]' (click)='collapse()'>
            <span class='	glyphicon glyphicon-earphone'></span> Deactivated Numbers
          </a>
          <ul class="stats">
            <li>
              <ul>
                <li class="total">
                  <span>Total<span class="badge">{{ accountStats.TotalAccounts }}</span></span>
                </li>
                <li class="todo">
                  <span>Worked Today<span class="badge">{{ accountStats.WorkedToday }}</span></span>
                  <div class="percentage" [ngStyle]="{'width': accountStats.WorkedToday * 100 / accountStats.TotalAccounts + '%'}"></div>
                </li>
                <li class="worked">
                  <span>Total Worked<span class="badge">{{ accountStats.WorkedAccounts }}</span></span>
                  <div class="percentage" [ngStyle]="{'width': accountStats.WorkedAccounts * 100 / accountStats.TotalAccounts + '%'}"></div>
                </li>
                <li class="done">
                  <span>Completed Today<span class="badge">{{ accountStats.DoneAccounts }}</span></span>
                </li>
              </ul>
            </li>
          </ul>
        </li>
        <li [routerLinkActive]='["link-active"]' *ngIf="auth.authenticated && auth.user && auth.user.textRepliesAccess">
          <a [routerLink]='["/text-replies"]' (click)='collapse()'>
            <span class='glyphicon glyphicon-phone'></span> Text Replies
          </a>
        </li>
        <li [routerLinkActive]='["link-active"]' *ngIf="auth.authenticated && auth.user && auth.user.textRepliesAccess">
          <a [routerLink]='["/email-replies"]' (click)='collapse()'>
            <span class='glyphicon glyphicon-envelope'></span> Email Replies
          </a>
        </li>        
        <li [routerLinkActive]='["link-active"]' *ngIf="auth.authenticated && auth.user && auth.user.agentDNCEntriesAccess">
          <a [routerLink]='["/agent-dnc-entries"]' (click)='collapse()'>
            <span class='	glyphicon glyphicon-earphone'></span> Agent DNC Entries
          </a>
          <ul class="stats">
            <li>
              <ul>
                <li class="total">
                  <span>Total<span class="badge">{{ accountStats.TodoDNCNumbers }}</span></span>
                  <div class="percentage" [ngStyle]="{'width': accountStats.TodoDNCNumbers * 100 / accountStats.TotalDNCNumbers + '%'}"></div>
                </li>
                <li class="done">
                  <span>Completed Today<span class="badge">{{ accountStats.DoneDNCNumbers }}</span></span>
                  <div class="percentage" [ngStyle]="{'width': accountStats.DoneDNCNumbers * 100 / accountStats.TotalDNCNumbers + '%'}"></div>
                </li>
              </ul>
            </li>
          </ul>
        </li>
        <li [routerLinkActive]='["link-active"]' *ngIf="auth.authenticated && auth.user && auth.user.referenceAutomationExceptionsAccess">
          <a [routerLink]='["/reference-automation-exceptions"]' (click)='collapse()'>
            <span class='glyphicon glyphicon-envelope'></span> Reference Exceptions
          </a>
        </li>
        <li *ngIf="auth.authenticated && auth.user && auth.user.isUserManager">
          <a>
            <span class='glyphicon glyphicon-user'></span> Users
          </a>
          <ul class="submenu">
            <li [routerLinkActive]='["link-active"]' style="padding-left:5%"><a [routerLink]='["/new-users"]' (click)='collapse()'><span class='glyphicon glyphicon-minus'></span>New Users</a></li>
            <li [routerLinkActive]='["link-active"]' style="padding-left:5%"><a [routerLink]='["/user-manager"]' (click)='collapse()'><span class='glyphicon glyphicon-minus'></span>Active Users</a></li>
          </ul>
        </li>
        <li>
          <a (click)='toggleSignInOut()' [routerLink]="">
            <div *ngIf="auth.authenticated">
              <span class='	glyphicon glyphicon-lock'></span> Sign Out
            </div>
            <div *ngIf="!auth.authenticated">
              <span class='	glyphicon glyphicon-lock'></span> Sign In
            </div>
          </a>
        </li>

        <li *ngIf="auth.user" class="info">
          <br><br><br>
          User: {{ auth.user.userId }}<br>
          Flex: {{ auth.user.fiservUserId }}<br>
          Lookup: {{ auth.user.lookupUserId }}
          <span *ngIf="auth.user.isUserManager">
            <br>Manager
          </span>
        </li>
        <li *ngIf="auth.settings" class="info">
          Environment<br>
          Flex: {{ auth.settings.fiserv }}<br>
          Database: {{ auth.settings.dataWarehouse }}<br>
        </li>

      </ul>

    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/nav-menu/nav-menu.component.html